export const MAX_AUTO_HEIGHT_PX = 3000;
export const MIN_AUTO_HEIGHT_PX = 44; // 2 rows + 1 margin
export const MIN_AUTO_HEIGHT_ROWS = 2;

export const DEFAULT_CONTROL_LAYOUT = {w: 8, h: 2};

export const FIXED_HEADER_GROUP_COLS = 35;
export const DASHKIT_COLS_AMOUNT = 36;
export const FIXED_HEADER_GROUP_LINE_MAX_ROWS = 2;

export const FIXED_GROUP_CONTAINER_ID = '__fixGCont';
export const FIXED_GROUP_HEADER_ID = '__fixHead';

export const DEFAULT_DASH_MARGINS: [number, number] = [8, 8];
export const MIN_DASH_MARGIN = 0;
export const MAX_DASH_MARGIN = 22;
export const DASH_MARGIN_STEP = 2;
export const MIN_DASH_ROW_HEIGHT = MIN_AUTO_HEIGHT_PX;

export const DEBOUNCE_RENDER_TIMEOUT = 200;
